import { VertButton, VertModal, VertTypography } from "@vertem-core/vertice-ds";
import React, { useState } from "react";
import '../../Assets/styles/default/components/Modal/ModalConfirmRaiting.less'
import CircleCheck from "components/Concierge/Icons/circleCheck";

const ModalConfirmRating = ({onCancel}) => {
  //STATES
  const [confirmRating, setConfirmRating] = useState(true);

  const cancelModal = () => {
    setConfirmRating(false);
    return onCancel();
}
  return (
    <div>
        <VertModal width={400} 
        open={confirmRating}
        onCancel={cancelModal}
        >
          <div className="modal-confirm-raiting">
            <div className="confirm-raiting-check">
              <CircleCheck width={48} height={48} strokeWidth={2}  />
            </div>

            <div className="container-confirm-raiting">
            <VertTypography.Title level={5}>
              Avaliação enviada com sucesso!
            </VertTypography.Title>

              <span className="txt-confirm-raiting">
              Estamos validando sua avaliação.<br/>
              Pode levar alguns dias para ela aparecer em nosso site.
              </span>
            </div>

            <VertButton
            className="btn-confirm-raiting"
            type="highlight"
            size="small"
            onClick={cancelModal}
            >
              Entendi
            </VertButton>
          </div>
        </VertModal>
    </div>
  );
};

export default ModalConfirmRating;
